"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAvatarURI = _getAvatarURI;
exports.makeCacheAtom = makeCacheAtom;
exports.makeQueueAtom = makeQueueAtom;
exports.queuer = queuer;
exports.makeQueuer = makeQueuer;
exports.toDimensionBuckets = toDimensionBuckets;
exports.toBatches = toBatches;
exports.flush = flush;
exports.makeAvatarResolver = makeAvatarResolver;
exports.getAvatarResolver = exports.LAST_TRY_DELAY = exports.SECOND_TRY_DELAY = exports.FIRST_TRY_DELAY = void 0;

var _utils = require("./lib/utils");

var Atom = _interopRequireWildcard(require("./lib/Atom"));

var _AvatarAPI = require("./api/AvatarAPI");

var _defaultFetchAvatars = _interopRequireDefault(require("./api/defaultFetchAvatars"));

var _immutable = require("immutable");

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _LookupRecord = _interopRequireDefault(require("./Records/LookupRecord"));

var FIRST_TRY_DELAY = 200;
exports.FIRST_TRY_DELAY = FIRST_TRY_DELAY;
var SECOND_TRY_DELAY = 1000;
exports.SECOND_TRY_DELAY = SECOND_TRY_DELAY;
var LAST_TRY_DELAY = 4000;
/**
 * Given the various state Atoms, retrieves a URI from the cache or adds the
 * lookup to the queue.
 *
 * @param  {Atom<Map<LookupRecord,?string>>}
 * @param  {Atom<Set<LookupRecord>>}
 * @param  {Function}
 * @param  {Function}
 * @param  {number}
 * @param  {Lookup}
 * @return {?LookupRecord}
 */

exports.LAST_TRY_DELAY = LAST_TRY_DELAY;

function _getAvatarURI(cacheAtom, pendingAtom, enqueue, fetcher, portalId, lookup) {
  (0, _invariant.default)(typeof fetcher === 'function', 'expected `fetcher` to be a function but got `%s`', fetcher);
  (0, _invariant.default)(typeof portalId === 'number' || !lookup.requiresPortalId(), 'expected `portalId` to be a number or the lookup to not require a portalId but got `%s`', portalId);
  (0, _invariant.default)(lookup instanceof _LookupRecord.default, 'expected `lookup` to be a LookupRecord but got `%s`', lookup);
  var avatars = Atom.deref(cacheAtom);

  if (avatars.has(lookup)) {
    return avatars.get(lookup);
  }

  if (!Atom.deref(pendingAtom).has(lookup)) {
    enqueue(fetcher, portalId, _immutable.Set.of(lookup));
  }

  return undefined;
}
/**
 * @param  {?Map<LookupRecord, ?string>}
 * @return {Atom<Map<LookupRecord, ?string>>}
 */


function makeCacheAtom() {
  var initialCache = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
  return Atom.atom(initialCache, _immutable.Map.isMap);
}
/**
 * @param  {?Set<LookupRecord>}
 * @return {Atom<Set<LookupRecord>>}
 */


function makeQueueAtom() {
  var initialQueue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Set)();
  return Atom.atom(initialQueue, _immutable.Set.isSet);
}
/**
 * Adds lookups to the queue and schedules a queue flush.
 *
 * @param  {Atom<Set<LookupRecord>>}
 * @param  {Function}
 * @param  {Function}
 * @param  {number}
 * @param  {Set<LookupRecord>}
 * @return {void}
 */


function queuer(queueAtom, flushQueue, fetcher, portalId, lookups) {
  (0, _invariant.default)(_immutable.Set.isSet(lookups) && !lookups.isEmpty(), 'expected `lookups` to be a non-empty Set but got `%s`', lookups);
  Atom.swap(queueAtom, function (current) {
    return current.union(lookups);
  });
  flushQueue(fetcher, portalId);
}
/**
 * Creates a queing function bound to a queue Atom.
 *
 * @param  {Function}
 * @param  {Function}
 * @param  {Atom<Map<LookupRecord,?string>>}
 * @param  {Atom<Set<LookupRecord>>}
 * @param  {Function}
 * @return {Function}
 */


function makeQueuer(queueAtom, doEnqueue, doFlush, cacheAtom, pendingAtom, nextEnqueue) {
  var flushQueue = function flushQueue() {
    for (var _len = arguments.length, partialArgs = new Array(_len), _key = 0; _key < _len; _key++) {
      partialArgs[_key] = arguments[_key];
    }

    return doFlush.apply(void 0, [cacheAtom, queueAtom, pendingAtom, nextEnqueue].concat(partialArgs));
  };

  return function () {
    for (var _len2 = arguments.length, partialArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      partialArgs[_key2] = arguments[_key2];
    }

    return doEnqueue.apply(void 0, [queueAtom, flushQueue].concat(partialArgs));
  };
}
/**
 * Splits lookups into buckets based on their dimensions so the fetcher can make
 * separate calls for each dimension.
 *
 * @param  {Set<LookupRecord>}
 * @return {Map<?number, Set(LookupRecord)>}
 */


function toDimensionBuckets(lookups) {
  return lookups.reduce(function (dimensionBuckets, lookup) {
    return dimensionBuckets.update(lookup.dimensions, function (maybeSet) {
      return typeof maybeSet === 'undefined' ? _immutable.Set.of(lookup) : maybeSet.add(lookup);
    });
  }, (0, _immutable.Map)());
}
/**
 *  Splits the lookup set into batches in order so the fetcher can make
 *  batch requests to Avatars
 *
 * @param  {Set<LookupRecord>}
 * @param  {number}
 * @return {List<Set<LookupRecord>>}
 */


function toBatches(lookupSet) {
  var batchSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  (0, _invariant.default)(typeof batchSize === 'number' && batchSize > 0, 'expected `batchSize` to number greater than 0 but got `%s`', batchSize);
  return lookupSet.reduce(function (batches, lookup) {
    if (batches.last().size >= batchSize) {
      return batches.push(_immutable.Set.of(lookup));
    }

    return batches.set(-1, batches.last().add(lookup));
  }, _immutable.List.of((0, _immutable.Set)()));
}
/**
 * Try to resolve the contents of a queue, adding hits to the cache and pushing
 * retries to the next queue.
 *
 * @param  {Atom<Map<LookupRecord,?string>>}
 * @param  {Atom<Set<LookupRecord>>}
 * @param  {Atom<Set<LookupRecord>>}
 * @param  {Function}
 * @param  {Function}
 * @param  {number}
 * @return {void}
 */


function flush(cacheAtom, queueAtom, pendingAtom, nextFlush, fetcher, portalId) {
  var lookups = Atom.deref(queueAtom);

  if (lookups.isEmpty()) {
    return;
  }

  Atom.swap(pendingAtom, function (current) {
    return current.union(lookups);
  });
  Atom.swap(queueAtom, function (current) {
    return current.clear();
  });
  toDimensionBuckets(lookups).forEach(function (lookupSet, dimensions) {
    toBatches(lookupSet).forEach(function (batch) {
      (0, _AvatarAPI.fetchAvatars)(fetcher, portalId, batch, dimensions).then(function (_ref) {
        var retry = _ref.retry,
            updates = _ref.updates;
        Atom.swap(pendingAtom, function (current) {
          return current.subtract(lookups);
        });
        Atom.swap(cacheAtom, function (current) {
          return current.merge(updates);
        });

        if (nextFlush && !retry.isEmpty()) {
          nextFlush(fetcher, portalId, retry);
        }
      }).done();
    });
  });
}
/**
 * Factory that creates the various state Atoms and bound functions that compose
 * an AvatarResolver and cache.
 *
 * @return {Object}
 */


function makeAvatarResolver() {
  var cacheAtom = makeCacheAtom();
  var pendingAtom = makeQueueAtom();
  var firstQueueAtom = makeQueueAtom();
  var secondQueueAtom = makeQueueAtom();
  var lastQueueAtom = makeQueueAtom();
  var enqueueLastTry = makeQueuer(lastQueueAtom, queuer, (0, _utils.debounce)(flush, LAST_TRY_DELAY), cacheAtom, pendingAtom);
  var enqueueSecondTry = makeQueuer(secondQueueAtom, queuer, (0, _utils.debounce)(flush, SECOND_TRY_DELAY), cacheAtom, pendingAtom, enqueueLastTry);
  var enqueueFirstTry = makeQueuer(firstQueueAtom, queuer, (0, _utils.debounce)(flush, FIRST_TRY_DELAY), cacheAtom, pendingAtom, enqueueSecondTry);
  return {
    /**
     * The Atom that stores the lookup => url cache. It's usually best to use
     * the helper methods (getAvatarURI, setAvatarURI, etc.) rather than using
     * the cache directly.
     *
     * @prop  {Atom<Map<LookupRecord,?string>>}
     */
    avatars: cacheAtom,

    /**
     * Returns an avatar uri from the cache or queues the lookup to be fetched.
     *
     * @param  {LookupRecord}
     * @param  {Function}       fetcher that returns a promise for the API response
     * @param  {number}         portal id
     * @return {?string}        avatar url
     */
    getAvatarURI: function getAvatarURI(lookup) {
      var fetcher = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _defaultFetchAvatars.default;
      var portalId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _PortalIdParser.default.get();
      return _getAvatarURI(cacheAtom, pendingAtom, enqueueFirstTry, fetcher, portalId, lookup);
    },

    /**
     * Associate an avatar uri with a lookup in the cache. This is useful when
     * client interaction changes the image an avatar should display (i.e. the
     * user uploaded a new profile photo for a contact).
     *
     * @param  {LookupRecord}   lookup (email or domain)
     * @param  {?string}        new url or null
     * @param  {Function}       fetcher that returns a promise for the API response
     * @param  {number}         portal id
     * @return {?string}        avatar url
     */
    setAvatarURI: function setAvatarURI(lookup, value) {
      var key = lookup;
      (0, _invariant.default)(key instanceof _LookupRecord.default, 'expected `lookup` to be an instance of LookupRecord but got `%s`', lookup);
      (0, _invariant.default)(value === null || typeof value === 'string' && value.length > 0, 'expected `value` to be a non-empty string or `null` but got `%s`', value);
      Atom.swap(cacheAtom, function (current) {
        return current.set(lookup, value).map(function (cachedValue, cachedLookup) {
          return lookup.isSameAs(cachedLookup) ? value : cachedValue;
        });
      });
    },

    /**
     * Register a callback to be triggered whenever the avatars caches changes.
     *
     * @param  {Function}  callback
     * @return void
     */
    watch: function watch() {
      for (var _len3 = arguments.length, partialArgs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        partialArgs[_key3] = arguments[_key3];
      }

      return Atom.watch.apply(Atom, [cacheAtom].concat(partialArgs));
    },

    /**
     * Unregister a callback that was previously registered with `watch`.
     *
     * @param  {Function}  callback
     * @return void
     */
    unwatch: function unwatch() {
      for (var _len4 = arguments.length, partialArgs = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        partialArgs[_key4] = arguments[_key4];
      }

      return Atom.unwatch.apply(Atom, [cacheAtom].concat(partialArgs));
    }
  };
}
/**
 * Returns the AvatarResolver singleton used by UIAvatar.
 *
 * @return {Object}
 */


var getAvatarResolver = (0, _utils.once)(makeAvatarResolver);
exports.getAvatarResolver = getAvatarResolver;